import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { PreviewCarousel } from './PreviewCarousel';
import { bonuses, volumes } from '../data/offer';
import type { Volume } from '../types/content';
const accentStyles: Record<Volume['accent'], {
  border: string;
  text: string;
}> = {
  info: {
    border: 'border-info/30',
    text: 'text-info'
  },
  primary: {
    border: 'border-primary-soft/30',
    text: 'text-primary-soft'
  },
  highlight: {
    border: 'border-highlight/30',
    text: 'text-highlight'
  },
  danger: {
    border: 'border-danger-soft/30',
    text: 'text-danger-soft'
  }
};
export function ProductOffer() {
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-151" data-mp="uh7a9gd2bhjy">
        <div className="mx-auto max-w-5xl" data-id="element-152" data-mp="fjevwrj94z7c">
          <header className="text-center" data-id="element-153" data-mp="fkg6yw09plp2">
            <h2 className="font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-154" data-mp="ki8akna9yw93">
              KIT EXPRESIÓN CORPORAL CONSCIENTE™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-[17px] font-medium" data-id="element-155" data-mp="3ldrqpr0j2vb7">
              Tu sistema práctico de movimiento consciente para aflojar tensiones cotidianas, explorar la expresión emocional y recuperar momentos de calma.
            </p>
          </header>
          <div className="mx-auto mt-10 max-w-3xl rounded-2xl border border-primary/30 bg-canvas px-5 py-7 text-center sm:px-8" data-id="element-156" data-mp="3qdml44jii310">
            <p className="text-foreground-muted" data-id="element-157" data-mp="32pd4ri52i7h9">
              Con el <b className="text-foreground" data-id="element-158" data-mp="2xpqr57lbup7x">Método AER</b>, seguís tres pasos sencillos:
            </p>
            <p className="mt-4 font-display text-xl font-bold text-primary-soft sm:text-3xl" data-id="element-159" data-mp="3bgn79yy2hdy3">
              AFLOJAR <span className="text-highlight" aria-hidden="true" data-id="element-160" data-mp="36pn8sp9aunth">→</span> EXPRESAR <span className="text-highlight" aria-hidden="true" data-id="element-161" data-mp="36oc4mobxze1u">→</span> RECONECTAR
            </p>
            <p className="mt-4 text-sm text-foreground-subtle sm:text-base" data-id="element-162" data-mp="2iy82kleejmcy">
              Sin coreografías. Sin equipamiento especial. Sin tener que inventar tus propias rutinas.
            </p>
          </div>
          <h3 className="mt-12 text-center font-display text-2xl font-bold" data-id="element-163" data-mp="mxg1o7b48orl">
            📚 3 VOLÚMENES COMPLETOS
          </h3>
          <div className="mt-7 space-y-5" data-id="element-164" data-mp="rnwg9uqoagfj">
            {volumes.map((volume, index) => {
            const accent = accentStyles[volume.accent];
            return <motion.article key={volume.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.06
            }} className={`flex gap-5 rounded-2xl border ${accent.border} bg-canvas p-5 sm:p-7`} data-id="element-165" data-mp="wp3nnsowldlo" data-mpi={index}>
                  <BookOpenIcon className={`mt-1 h-7 w-7 shrink-0 ${accent.text}`} aria-hidden="true" data-id="element-166" data-mp="duoqm8m5jv0h" />
                  <div className="flex-1" data-id="element-167" data-mp="1kf6btxpp5zf0">
                    <p className={`text-xs font-bold tracking-brand ${accent.text}`} data-id="element-168" data-mp="1pb54hxi263l8">
                      {volume.label}
                    </p>
                    <h4 className="mt-1 font-display text-lg font-bold sm:text-xl" data-id="element-169" data-mp="39w1ufnime543">
                      {volume.title}
                    </h4>
                    <p className="mt-1 text-sm font-semibold tracking-label text-foreground-subtle" data-id="element-170" data-mp="303e2b62l4pbp">
                      {volume.subtitle}
                    </p>
                    <ul className="mt-4 space-y-2" data-id="element-171" data-mp="2v38dryrm3ixu">
                      {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-172" data-mp="2q7axttk9gell">
                          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-173" data-mp="2h5a4v8w28epq" />
                          {item}
                        </li>)}
                    </ul>
                    <p className="mt-5 border-t border-foreground/10 pt-4 text-sm sm:text-base" data-id="element-174" data-mp="fdx48w14kszh">
                      <span className="font-semibold text-foreground-subtle" data-id="element-175" data-mp="aeu51s7ttgzf">Resultado: </span>
                      <span className={`font-bold italic ${accent.text}`} data-id="element-176" data-mp="346tv0blnpzhj">{volume.result}</span>
                    </p>
                  </div>
                </motion.article>;
          })}
          </div>
        </div>
      </section>
      <PreviewCarousel data-id="element-177" data-mp="2u9ffqfbgzgqt" />
      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-178" data-mp="2u7un4v8pu7vl">
        <div className="mx-auto max-w-5xl" data-id="element-179" data-mp="2z7h0d4ojno4e">
          <header className="text-center" data-id="element-180" data-mp="2z65vf1jd4abp">
            <GiftIcon className="mx-auto h-10 w-10 text-highlight" aria-hidden="true" data-id="element-181" data-mp="2kiugqqrvwa7d" />
            <h2 className="mt-3 font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-182" data-mp="2kh003onnb493">
              5 BONOS DE REGALO
            </h2>
          </header>
          <div className="mt-10 space-y-4" data-id="element-183" data-mp="2bjfwwa682xvu">
            {bonuses.map(({
            number,
            title,
            detail,
            items,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-highlight/20 bg-surface p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-184" data-mp="21joxbu2t1sow">
                <span className="w-fit whitespace-nowrap rounded-lg bg-highlight/10 px-3 py-2 font-bold text-highlight" data-id="element-185" data-mp="26kw7fzsf73yq">
                  🎁 BONO {number}
                </span>
                <div className="flex-1" data-id="element-186" data-mp="1ixhh78nrlqlh">
                  <h3 className="font-bold" data-id="element-187" data-mp="1wv63mkxhd5sn">{title}</h3>
                  {detail && <p className="mt-2 text-sm leading-relaxed text-foreground-muted" data-id="element-188" data-mp="1wtcrwr80fvds">
                      {detail}
                    </p>}
                  <ul className="mt-3 space-y-1.5" data-id="element-189" data-mp="25vm0vcnmrgp2">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted" data-id="element-190" data-mp="25trjg8bki6pq">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-191" data-mp="2flxghwgofebs" />
                        {item}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-192" data-mp="2pjldyu5o2zxn">
                  <span className="text-xs font-semibold text-foreground-faint" data-id="element-193" data-mp="2phqsneqhh5t1">VALOR:</span>
                  <span className="text-sm text-foreground-faint line-through" data-id="element-194" data-mp="2kixf5mb75esv">
                    {value}
                  </span>
                  <span className="rounded-full bg-primary-soft px-3 py-1 text-sm font-bold text-canvas" data-id="element-195" data-mp="2wn1md6hvfnbp">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-highlight/30 bg-highlight/10 p-6 text-center" data-id="element-196" data-mp="36de4yt64l6f7">
            <p className="text-xs font-bold tracking-brand text-highlight" data-id="element-197" data-mp="3bb5ytsqbz2m1">
              VALOR TOTAL DE LOS BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-foreground-subtle line-through" data-id="element-198" data-mp="3fbznioblklfz">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-highlight" data-id="element-199" data-mp="3pbyu4fogi1q7">
              GRATIS con tu Kit Expresión Corporal Consciente™
            </p>
          </div>
        </div>
      </section>
    </>;
}